// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__dkmSB","avatar_img":"Avatar_avatar_img__i3CrB","avatar_no_avatar":"Avatar_avatar_no_avatar__KCioI"};